interface CreatePollingIntervalOptions<TData> {
    isPending: (data: TData | undefined) => boolean;
    interval?: number;
    timeout: number;
}

export interface PollingInterval<TData> {
    (query: { state: { data?: TData } }): number | false;
    reset: () => void;
}

export function createPollingInterval<TData>({
    isPending,
    interval = 5000,
    timeout
}: CreatePollingIntervalOptions<TData>): PollingInterval<TData> {
    let startedAt: number | null = null;

    const refetchInterval = (query: { state: { data?: TData } }) => {
        if (!isPending(query.state.data)) {
            startedAt = null;

            return false as const;
        }

        startedAt ??= Date.now();

        if (Date.now() - startedAt > timeout) {
            startedAt = null;

            return false as const;
        }

        return interval;
    };

    refetchInterval.reset = () => {
        startedAt = null;
    };

    return refetchInterval;
}
